import { Button, CloseIcon, IconButton, Modal, Typography } from "@povio/ui";
import Image from "next/image";

import TokenUsageExceededImage from "@/assets/images/general/DoggySad.png";
import { useOverlayQueueStore } from "@/providers/overlay/overlay-queue.store";

export const QuotaExceededModal = () => {
  const { currentOverlay, dequeueOverlay } = useOverlayQueueStore();
  const isOpen = currentOverlay?.type === "quota-exceeded";

  return (
    <Modal
      isOpen={isOpen}
      onClose={dequeueOverlay}
    >
      <div className="flex w-full items-center justify-between">
        <Typography
          size="title-5"
          variant="prominent-1"
        >
          Token Usage Exceeded
        </Typography>
        <IconButton
          label="Close"
          size="none"
          color="secondary"
          variant="ghost"
          icon={CloseIcon}
          onPress={dequeueOverlay}
        />
      </div>
      <Image
        src={TokenUsageExceededImage}
        alt="Token usage exceeded"
        width={500}
        height={400}
      />
      <Typography size="body-4">
        You&apos;ve exceeded your calculations usage for today. We&apos;ll refill you with 10 Tokens tomorrow.
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        size="s"
        onPress={dequeueOverlay}
      >
        Close
      </Button>
    </Modal>
  );
};
